/**
 * O endereço de um chamado na central e-Niterói (GLPI).
 *
 * O `idExterno` é o id do ticket no GLPI, e a tela de ticket do GLPI é `front/ticket.form.php?id=`.
 * A raiz é a mesma da API configurada no servidor (`app.glpi.api-url`, `https://e.niteroi.rj.gov.br/apirest.php`);
 * fica aqui como constante porque é o único lugar que a usa e não é segredo. Se o endereço mudar,
 * muda numa linha.
 */
const RAIZ_DO_ENITEROI = 'https://e.niteroi.rj.gov.br'

/**
 * @param idExterno o número do chamado como o e-Niterói o identifica
 * @returns o endereço da tela do chamado
 */
export function enderecoDoChamadoNoENiteroi(idExterno: string): string {
  return `${RAIZ_DO_ENITEROI}/front/ticket.form.php?id=${encodeURIComponent(idExterno)}`
}
